import { render, staticRenderFns } from "./AppInbox.vue?vue&type=template&id=4b9fc9ba&scoped=true&"
import script from "./AppInbox.vue?vue&type=script&lang=js&"
export * from "./AppInbox.vue?vue&type=script&lang=js&"
import style0 from "./AppInbox.vue?vue&type=style&index=0&id=4b9fc9ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9fc9ba",
  null
  
)

export default component.exports